import { makeStyles } from "@material-ui/core";

export const paymentPlansStyle = makeStyles((theme) => ({
  planBenefit: () => ({
    fontFamily: "Lato",
    fontWeight: "400",
    color: "#000000",
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.only("xs")]: {
      marginBottom: "15px",
    },
  }),
  title: () => ({
    color: "#F15A28",
    fontFamily: "Lato",
    fontWeight: "700",
    fontSize: theme.typography.pxToRem(18),
  }),
  premiumPlanTitle: {
    backgroundColor: "#FEEFEA",
  },
  priceContainer: {
    display: "flex",
  },
  priceSign: {
    fontFamily: "Inter",
    fontWeight: "700",
    fontSize: theme.typography.pxToRem(18),
    paddingTop: "17px",
  },
  price: {
    fontFamily: "Inter",
    fontWeight: "700",
    fontSize: theme.typography.pxToRem(38),
  },
  period: {
    color: "#747F9D",
    fontFamily: "Lato",
    fontWeight: "400",
    fontSize: theme.typography.pxToRem(18),
    marginTop: "-7px",
  },
  periodDetails: {
    color: "#747F9D",
    fontFamily: "Lato",
    fontWeight: "400",
    fontSize: theme.typography.pxToRem(12),
  },
  benefitsContainer: {
    marginTop: "10px",
  },
  checkedIcon: {
    marginRight: "23px",
  },
  freeBenefitsContainer: {
    [theme.breakpoints.up("sm")]: {
      marginTop: "33px",
    },
  },
  disabledBenefit: {
    color: "#999999 !important",
  },
  currentPlan: () => ({
    fontFamily: "Lato",
    fontWeight: "700",
    fontSize: theme.typography.pxToRem(16),
  }),
  upgradeMembership: {
    backgroundColor: "#0344DC",
    color: "white",
    borderRadius: "20px",
    fontFamily: "Inter",
    fontWeight: "600",
    fontSize: theme.typography.pxToRem(16),
    textTransform: "none",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#022984",
    },
    "& .MuiButton-endIcon": {
      color: "#22D9BB",
    },
  },
  buttonContainer: {
    height: "50px",
    marginTop: "10px",
  },
  cardContent: {
    padding: "21px 25px",
  },
  benefitBold: {
    fontWeight: "bold !important",
  },
}));
